import { render } from "./BranchLevelSettings.vue?vue&type=template&id=26becd84&scoped=true"
import script from "./BranchLevelSettings.vue?vue&type=script&lang=js"
export * from "./BranchLevelSettings.vue?vue&type=script&lang=js"

import "./BranchLevelSettings.vue?vue&type=style&index=0&id=26becd84&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26becd84"]])

export default __exports__